<template>
  <view class="pft-raise-or-fall-container" :style="style" :flex="flex">
    <view class="text-title" :style="titleStyle">{{ title }}</view>
    <template v-if="componentLoading">
      <Loading />
    </template>
    <view v-else class="text-data" flex="dir:left cross:center" :style="dataContainerStyle">
      <view flex="dir:left cross:bottom">
        <view class="data-val" :style="{ ...dataStyle, color: directionColor }">
          {{ formatData(dataVal || data) }}
        </view>
        <view class="data-suffix" v-if="suffix" :style="{ ...suffixStyle, color: directionColor }">
          {{ typeof suffix === "function" ? suffix(dataVal || data) : suffix }}
        </view>
      </view>
      <img
        :src="isIncrease ? upIcon : downIcon"
        :style="{
          width: directionSize,
          height: directionSize,
        }"
      />
    </view>
  </view>
</template>
<script lang="ts" setup>
import { ref, nextTick, computed } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import numeral from "numeral"

import upIcon from "@p-v/asset/image/icon_up@2x.png"
import downIcon from "@p-v/asset/image/icon_down@2x.png"

interface DataTextProps {
  title: string
  data: string | number
  format?: string | ((data: string | number) => string)
  suffix?: string | ((data: string | number) => string)
  flex?: string
  style?: { [key: string]: string | number }
  titleStyle?: { [key: string]: string | number }
  dataStyle?: { [key: string]: string | number }
  suffixStyle?: { [key: string]: string | number }
  dataContainerStyle?: { [key: string]: string | number }
  empty: string | undefined
  showDirection?: boolean
  directionSize?: string
  raiseColor?: string
  fallColor?: string
}

defineOptions({
  name: "RaiseOrFall",
})

const props = withDefaults(defineProps<DataTextProps>(), {
  title: () => "",
  data: () => "",
  suffix: undefined,
  flex: () => "dir:left main:justify cross:center",
  format: () => "0,0",
  style: () => ({}),
  titleStyle: () => ({}),
  dataStyle: () => ({
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "bold",
  }),
  dataContainerStyle: () => ({}),
  empty: undefined,
  directionSize: () => "12px",
  raiseColor: () => "#F9614A",
  fallColor: () => "#63E7B7",
})

const formatData = (val: string | number) => {
  if (val === undefined || val === null || val == 0) {
    if (props.empty) return props.empty
    if (val == 0) {
      if (typeof props.format === "function") {
        return props.format(val)
      }
      return numeral(Number(val)).format(props.format)
    } else {
      return ""
    }
  }
  if (typeof val === "string" && /\d+/.test(val) === false) {
    return val
  }
  if (typeof props.format === "function") {
    return props.format(val)
  }
  return numeral(Number(val)).format(props.format)
}

const componentLoading = ref<boolean>(true)

const dataVal = ref<string | number>("")

const isIncrease = ref<boolean>(false)

const directionColor = computed(() => {
  return isIncrease.value ? props.raiseColor : props.fallColor
})

const loading = () => {
  componentLoading.value = true
}

const setData = (val: string, isRaise?: boolean) => {
  componentLoading.value = false
  dataVal.value = Math.abs(Number(val))
  if (isRaise !== undefined) {
    isIncrease.value = isRaise
  } else {
    isIncrease.value = Number(val) > 0
  }
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-raise-or-fall-container {
  box-sizing: border-box;
  width: 100%;
  .text-title {
    height: 20px;
    font-family:
      "Segoe UI",
      Segoe UI;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 20px;
    flex-shrink: 0;
  }
  .text-data {
    // width: 100%;
    .data-val {
      font-family:
        "Segoe UI",
        Segoe UI;
      font-weight: bold;
      font-size: 28px;
      color: #2bb7f7;
      line-height: 33px;
    }
    .data-suffix {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.65);
      margin-left: 2px;
    }
    .data-percent {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #fcf072;
      margin-left: 8px;
    }
  }
}
</style>
